<template>
    <div>
        <img src="@/assets/images/bg1.jpg" class="bgImg" alt="">
        <div class="basic_wrap">
            <div class="login_bg">
                <!-- <div class="back_left" @click="$router.push('/index')"></div> -->
                <div class="big_tit">{{ $t('login.login') }}</div>
                <div class="language" style="right: 55px;width: 32px;height: 32px;" @click="toKefuLink">
                    <img :src="require('../../assets/images/kefu.png')">
                </div>
                <div class="language" @click="$router.push('/language')">
                    <!-- <img :src="require('../images/language/' + lang + '.png')"> -->
                    <img :src="require('../../assets/images/lang.png')">
                </div>
            </div>
            <div class="kefus" v-if="logo != ''">
                <img class="kefu_img" :src="logo">
            </div>
            <form class="form">
                <div class="cut_login">
                    <router-link class="cur" to="/login">{{ $t('login.signIn') }}
                        <div class="line"></div>
                    </router-link>
                    <router-link to="/register">{{ $t('login.signUp') }}
                        <div class="line"></div>
                    </router-link>
                </div>
                <div class="item mt">
                    <span class="icon">
                        <img src="../images/login/tel.png" alt="" />
                    </span>
                    <a class="text-phone" @click.stop="countryShow = !countryShow">
                        {{ data.country }} 
                    </a>
                    <input type="text" class="inp" v-model.trim="data.username"
                        :placeholder="$t('setpaypwd.pureNumber')" />
                    <div class="item_box" v-if="countryShow">
                        <div class="search-box">
                            <input type="text" v-model="searchCode" :placeholder="$t('搜索区号')" @input="inputFun"></input>
                        </div>
                        <a v-for="(item, index) in countrys" :key="index" :class="{ 'active': item.code === data.country }"
                            @click.stop="onSelect(item)">
                            {{ item.code }} {{ item.text }}
                        </a>
                    </div>
                </div>
                <div class="item">
                    <span class="icon"><img src="../images/login/lock.png" alt="" /></span>
                    <input :type="password" class="inp" v-model.trim="data.password"
                        :placeholder="$t('login.password')" />
                    <div class="eye_bi" @click="showPwd" :class="password == 'text' ? 'eye' : ''"></div>
                </div>
                <div class="item_reset_pwd">
                    <van-checkbox v-model="checked" icon-size="14px">{{ $t('login.remember') }}</van-checkbox>
                    <!-- <router-link class="reset_pwd" to="/forgetpwd">{{ $t('login.forget') }}</router-link> -->
                </div>
                <div class="flexs">
                    <van-checkbox v-model="checkeds" icon-size="14px" shape="square" checked-color="#3d96ff">
                        <span style="color: #333;">{{ $t('wytx') }}</span>
                    </van-checkbox>
                    <router-link style="color: #3d96ff;margin-left: 5px;" to="/xys">
                        {{ $t('用户协议') }}
                    </router-link>
                </div>
            </form>
            <div type="submit" class="basic_btn sbtn" :class="data.username == '' || data.password == '' ? 'no_touch' : ''
                " @click="submit">
                {{ $t('login.signInBtn') }}
            </div>

            <!-- <div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
            <img class="kefu_img" src="@/assets/images/logo.png">
        </div> -->
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Fetch from "../../utils/fetch"
import { CountDown, Checkbox, Toast } from 'vant'
Vue.use(Checkbox)

export default {
    name: "login",
    data() {
        return {
            countryShow: false,
            countrys: [],
            countrys2:[],
            lang: this.$i18n.locale,
            password: "password",
            show_kefu: false,
            msg_show: true,
            checked: true,
            checkeds: false,
            data: {
                username: "",
                password: "",
                country: localStorage.getItem('countryCode') || "+93"
            },
            logo: localStorage.getItem('logo') || '',
            kefu_link:'',
            searchCode:''
        };
    },
    created() {
        this.data.username = localStorage.getItem('login_username');
        this.data.password = localStorage.getItem('login_password');
        this.$parent.footer("user", false);
        Fetch("/index/webconfig").then((r) => {
            this.logo = r.data.logo
            this.kefu_link = r.data.kefu_link
            localStorage.setItem('logo', r.data.logo)
        });
        Fetch("/loan/countrys").then((r) => {
            this.countrys = r.data.map(x => {
                return { text: x.name, code: x.code }
            })
            this.countrys2 = r.data.map(x => {
                return { text: x.name, code: x.code }
            })
        });
    },
    mounted() {
        var that = this;
        document.body.addEventListener(
            "scroll",
            function () {
                if (!that.show_kefu) {
                    return;
                }
                that.show_kefu = false;
            },
            false
        );
        document.addEventListener(
            "click",
            function (ev) {
                if (ev.target.className != "kefu_img") {
                    that.show_kefu = false;
                }
            },
            false
        );
    },
    methods: {
        inputFun() {
            // 如果输入框为空，恢复原始数据
            if (!this.searchCode) {
                this.countrys = [...this.countrys2];
                return;
            }

            // 筛选逻辑：精准匹配区号数字
            const searchValue = this.searchCode;
            this.countrys = this.countrys2.filter(item => {
                // 去除code中的+号，只保留数字进行匹配
                const codeNumber = item.code.replace('+', '');
                // 精准完全相等匹配
                return codeNumber === searchValue;
            });
        },
        toKefuLink() {
            window.location.href = this.kefu_link
        },
        onSelect(action) {
            this.data.country = action.code
            this.countryShow = false
        },
        kefu_to() {
            if (this.show_kefu) {
                this.$router.push("/kefu");
            }
            this.show_kefu = !this.show_kefu;
        },
        showPwd() {
            if (this.password == "password") {
                this.password = "text";
            } else {
                this.password = "password";
            }
        },
        submit() {
            let that = this;
            if (!this.checkeds) {
                this.$toast(this.$t('qyexy'));
                return;
            }
            if (!this.data.username) {
                this.$toast(this.$t('setpaypwd.pureNumber'));
                return;
            }

            if (!this.data.password) {
                this.$toast(this.$t('login.passwordEmpty'));
                return;
            }

            // var regex = /^[A-Za-z0-9]{1,20}$/;
            // if (!regex.test(this.data.username)) {
            //     this.$toast(this.$t('login.phoneError'));
            //     return;
            // }

            if (this.checked) {
                localStorage.setItem('login_username', this.data.username);
                localStorage.setItem('login_password', this.data.password);
            }

            if (!this.checked) {
                localStorage.removeItem('login_username');
                localStorage.removeItem('login_password');
            }

            Fetch("/index/login", {
                username: this.data.username,
                password: this.data.password,
                country: this.data.country
            }).then((res) => {
                // console.log(res,'res')
                if (res.data && res.data.token) {
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('countryCode', that.data.country)
                    this.$toast({
                        background: "#07c160",
                        message: this.$t('login.signInSuccess'),
                    });
                    setTimeout(() => {
                        this.$router.push('/index')
                    }, 500);
                } else {
                    Toast(res.msg)
                }
            })
        },
    },
};
</script>

<style lang="less" scoped>
.logo-wrap {
    height: 100px;
}

.login_bg {
    width: 100%;
    height: 40px;
    overflow: hidden;
    background-size: 100% 100%;

    .language {
        position: absolute;
        top: 8px;
        right: 10px;
        height: 30px;

        img {
            height: 100%;
        }
    }
}

.text-phone {
    display: flex;
    align-items: flex-end;
    cursor: pointer;
    white-space: nowrap;
    padding-right: 20px;
    padding-bottom: 0px;
    line-height: 28px;
    background-image: url(~@/assets/images/xjt.png);
    background-repeat: no-repeat;
    background-size: 12px 12px;
    background-position: right 42px;
}

.basic_wrap {
    width: 100%;
    height: 100%;
    max-width: 750px;
    min-height: 100dvh;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    z-index: 10;
    background: rgba(0, 0, 0, 0.7);
    // background: url('~@/assets/images/bg1.jpg') no-repeat center center / cover;
}

.basic_wrap .form {
    margin: 5em auto;
    width: 90%;
    height: 312px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
    border-radius: 13px;
    padding: 31px 24px 0 24px;
}
.big_tit {
  color: #fff !important;
}
.cut_login {
    width: 207px;
    line-height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    text-align: center;
    margin: 0 auto;

    a {
        width: 50%;
        padding-bottom: 10px;
        color: #ceced0;
        position: relative;

        .line {
            width: 100%;
            height: 1px;
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: #f2f2f2;
        }
    }

    a.cur {
        color: #000;

        .line {
            height: 2px;
            background-image: linear-gradient(to right, #000, #000);
        }
    }
}

.mt {
    margin-top: 20px;
}

.item {
    height: 68px;
    border-bottom: 1px solid #f0f1f3;
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 4px;
    position: relative;

    .item_box {
        width: 100%;
        height: 320px;
        overflow-y: scroll;
        position: absolute;
        left: 0px;
        top: 72px;
        background: #fff;
        box-shadow: 0 0 3px #999;
        border-radius: 10px;
        padding: 10px 10px 0px 10px;
        z-index: 10;
        .search-box {
            height: 40px;
            width: 100%;
            background: #eee;
            border-radius: 8px;
            margin-bottom: 10px;
            padding: 0 10px;
            box-sizing: border-box;
            input {
                width: 100%;
                height: 100%;
                font-size: 14px;
            }
        }
        a {
            display: block;
            width: 100%;
            height: 38px;
            border-bottom: 1px solid #eee;
            line-height: 38px;
            padding: 0 8px;
        }

        .active {
            background: #eee;
        }
    }

    .icon {
        width: 32px;
        height: 27px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    input {
        height: 20px;
        margin-left: 7px;
        flex: 1;
        margin-bottom: 3px;
    }
}

.flexs {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;
    font-size: 14px;

    .van-checkbox {
        margin-top: 0px;
        margin-left: 5px;
    }
}

.item_reset_pwd {
    font-size: 14px;
    color: #3d96ff;
    text-align: right;
    margin-top: 10px;
    line-height: 20px;
}

.van-checkbox {
    margin-top: 20px;
}

.reset_pwd {
    color: #3d96ff;
    margin-top: -20px;
    display: block;
}

.basic_btn {
    margin: 39px auto 0 auto;
    box-shadow: 0 0 5px #eee;
}

.text-phone {
    width: fit-content;
}
</style>
